import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useLayout } from "../../hooks/useLayout";
import Sidebar from "../navigation/Sidebar";
import { useEffect } from "react";
import { Auth} from "aws-amplify";

export const ProtectedRoute = ({ children }) => {
  const { token,logout } = useAuth();
  const { setNavOpen } = useLayout();
  useEffect(() => {
    const interval = setInterval(() => {
      Auth.currentAuthenticatedUser({
        bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    }).catch(() => logout())
    }, 10*1000);
    return () => clearInterval(interval);
  }, [token, logout]);


  if (!token) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }


  // Shell layout (sizes/positions all in main.css): fixed sidebar on the
  // left, the topbar (NavigationBar.js, rendered by App.js) above the
  // scrolling content area, and a scrim that closes the mobile nav drawer.
  return (
    <div className='app-shell'>
      <aside className="app-sidebar">
        <Sidebar />
      </aside>
      <div className="app-scrim" onClick={() => setNavOpen(false)} />
      <main className='app-main'>
        <div className='main_content'>
          <Outlet/>
        </div>
      </main>
    </div>
    );
};
